import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { ErrorModal } from '../../../components/common';
const NotLicensedRepsModal = ({ restrictedRepsLicenseInfo, setRestrictedRepsLicenseInfo, }) => {
    const onCloseModal = () => {
        setRestrictedRepsLicenseInfo([]);
    };
    const renderModalContent = () => {
        const repsToDisplay = (_jsx("ul", { className: "mt-6 mb-4 pl-4", children: restrictedRepsLicenseInfo.map((repLicenseInfo) => {
                const licenses = [];
                repLicenseInfo.states.forEach((stateInfo) => {
                    if (stateInfo.is_license_needed && !stateInfo.has_license) {
                        licenses.push(`${stateInfo.name} state license`);
                    }
                });
                repLicenseInfo.counties.forEach((countyInfo) => {
                    if (countyInfo.is_license_needed && !countyInfo.has_license) {
                        licenses.push(`${countyInfo.name} county license`);
                    }
                });
                repLicenseInfo.municipalities.forEach((municipalityInfo) => {
                    if (municipalityInfo.is_license_needed && !municipalityInfo.has_license) {
                        licenses.push(`${municipalityInfo.name} municipality license`);
                    }
                });
                const licensesRow = licenses.join(' and ');
                return (_jsxs("li", { className: "w-full flex flex-col items-start gap-x-2 text-gray-900 pb-2", children: [_jsx("p", { children: `${repLicenseInfo.rep_full_name} (ID #${repLicenseInfo.rep_id})` }), _jsx("p", { className: "text-red-600", children: `Missing ${licensesRow}` })] }, repLicenseInfo.rep_id));
            }) }));
        return (_jsxs("div", { className: "text-sm text-gray-600 mb-4", children: [_jsx("p", { children: "The following sales reps:" }), repsToDisplay, _jsx("p", { children: "Are not licensed to sell in this location, please ensure the proper licenses are in place. Contact licensing team for support." })] }));
    };
    return restrictedRepsLicenseInfo.length > 0
        ? (_jsx(ErrorModal, { isOpened: restrictedRepsLicenseInfo.length > 0, onCancel: onCloseModal, title: "Unable to assign the polygon", children: renderModalContent() })) : null;
};
NotLicensedRepsModal.propTypes = {
    restrictedRepsLicenseInfo: PropTypes.arrayOf(PropTypes.object),
    setRestrictedRepsLicenseInfo: PropTypes.func,
};
export default NotLicensedRepsModal;
